import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import userService from "../../../services/user.service";
import { getFromLocalStorage } from "../../../utils/webStorage";
import TestimonialModal from "./AddOrEditTestimonial";

const AllTestimonial = ({ testimonialsHeadingId }) => {
  const [openModal, setOpenModal] = useState(false);
  const [testimonials, setTestimonials] = useState([]);
  const [testimonial, setTestimonial] = useState(undefined);
  const [fileName, setFileName] = useState("");
  const [name, setName] = useState("");
  const [captian, setCaptian] = useState("");
  const [content, setContent] = useState("");
  const [logoId, setLogoId] = useState("");

  // get testimonials
  useEffect(() => {
    getTestimonials();
  }, []);

  const getTestimonials = () => {
    userService.getTestimonials().then((res) => {
      const testimonialData = res.data.data.testimonialsDetailsResponses;
      setTestimonials(testimonialData);
    });
  };

  const closeModal = () => {
    setOpenModal(false);
    setTestimonial(undefined);
  };

  const OpenEditModal = (testimonial) => {
    if (testimonial) {
      setTestimonial(testimonial);
    }
    setOpenModal(true);
  };

  const changeHandlertestimonials = (event, formRef) => {
    let reader = new FileReader();
    let file = event.target.files[0];
    reader.readAsDataURL(file);
    handleSubmissionForLogo(file, formRef);
  };

  const handleSubmissionForLogo = (file, formRef) => {
    const currentUserId = getFromLocalStorage("currentUserId");
    const data = new FormData();
    data.append("file", file);
    data.append("userId", currentUserId);
    userService.postLogoForSuperAdmin(data).then((res) => {
      let logoId = res.data.data.id;
      let fileName = res.data.data.fileName;
      setLogoId(logoId);
      setFileName(fileName);
      formRef.current.setFieldValue("image", fileName);
    });
  };
  // add testimonials
  const handleAddForm = ({
    testimonialHeading,
    testimonialDescription,
    testimonialCaptian,
  }) => {
    userService
      .addTestimonialPost(
        testimonialHeading,
        testimonialCaptian,
        testimonialDescription,
        logoId,
        testimonialsHeadingId
      )
      .then((res) => {
        if (res.status === 200) {
          Swal.fire("Testimonial Added Successfully");
          getTestimonials();
          setOpenModal(false);
        }
      });
  };

  // update testimonials
  const updateTestimonial = ({
    testimonialHeading,
    testimonialDescription,
    testimonialCaptian,
  }) => {
    let imageId;
    if (logoId == null || logoId == "") {
      imageId = testimonial.uploadedLogo.id;
    } else {
      imageId = logoId;
    }
    userService
      .updateTestimonialsWeb(
        testimonialCaptian,
        testimonialDescription,
        testimonial.id,
        imageId,
        testimonialHeading,
        testimonial.testimonialsHeadingId
      )
      .then((res) => {
        if (res.status === 200) {
          setLogoId(null);
          Swal.fire("Testimonial Updated Successfully");
          getTestimonials();
          setOpenModal(false);
        }
      });
  };

  return (
    <div className="row">
      <div className="col-lg-6 col-12 col-md-12 ">
        <div className="clear10"></div>
        <h1 className="greyTEXT pb-3 pt-2 fs-18 semi-bold">Add Testimonial </h1>
        <div className="d-flex justify-content-center align-items-center testiBOX-new bg-light border">
          <button
            onClick={() => OpenEditModal()}
            type="button"
            class="testimonial-btn"
            data-toggle="modal"
            data-target="#exampleModal"
            data-whatever="@mdo"
          >
            + ADD
          </button>
        </div>
      </div>
      {testimonials?.map((testimonial, index) => (
        <div key={testimonial.id} className="col-lg-6 col-12 col-md-12 ">
          <div className="clear10"></div>
          <h1 className="greyTEXT pb-3 pt-2 fs-18 semi-bold mx-2">
            Testimonial {index + 1}{" "}
          </h1>
          <div className="get-testiBOX">
            <div className=" testiBox2">
              <div className="p-2">
                <img
                  className="testimonial-img"
                  alt=""
                  src={testimonial.uploadedLogo.filePath}
                ></img>
              </div>
              <div className="align-self">
                <div className="ml-2">
                  <label className=" text-dark fs-22 semi-bold mb-0">
                    {testimonial.name}
                  </label>

                  <p className="fs-14 semi-bold roleCLR ">
                    Role : {testimonial.captian}
                  </p>
                </div>
              </div>
            </div>
            <div className="clear10"></div>
            <p className="fs-16 regular greyTEXT testimonial-des">
              {testimonial.content}
            </p>
            <div className="clear10"></div>

            <h1
              className="fs-16 semi-bold txtblue cp mt-5 text-primary p-2"
              onClick={() => {
                OpenEditModal(testimonial);
              }}
            >
              <ul>EDIT</ul>
            </h1>
          </div>
        </div>
      ))}

      <TestimonialModal
        openModal={openModal}
        closeModal={closeModal}
        testimonial={testimonial}
        fileName={fileName}
        changeHandlertestimonials={changeHandlertestimonials}
        setTestimonial={setTestimonial}
        name={name}
        setName={setName}
        captian={captian}
        content={content}
        setCaptian={setCaptian}
        setContent={setContent}
        handleForm={testimonial ? updateTestimonial : handleAddForm}
      />
    </div>
  );
};

export default AllTestimonial;
